import _cloneDeep from 'lodash.clonedeep'
import { getConditionTypes } from '../condition/conditions'
import type { Pattern } from '../contexts/PatternContext'
import type { ConditionGroupType } from '../contexts/PatternTreeContext'

// Migrate legacy CHANGED_* conditions:
// - Move old RHS value to threshold
// - Set RHS to same indicator as LHS, targeting the previous candle
// (Lives outside PatternTreeContext so pure consumers — copy utils, the
// copilot's draft normalizer, tests — don't drag the provider's UI import
// tree; PatternTreeContext re-exports it for existing importers.)
export function migrateLegacyChangedConditions(pattern: Pattern): Pattern {
  if (!pattern) return pattern
  const migrated = _cloneDeep(pattern)

  const migrateGroups = (groups: ConditionGroupType[]) => {
    for (const group of groups) {
      for (const condition of group.conditions || []) {
        const ct = getConditionTypes(condition?.condition?.LHS?.field)?.find(
          (c: any) => c.value === condition?.condition?.conditionType
        )
        if (
          ct?.hasThreshold &&
          condition.condition.threshold === undefined &&
          condition.condition.LHS
        ) {
          // Migrate old RHS value to threshold
          if (condition.condition.RHS?.value !== undefined) {
            condition.condition.threshold = condition.condition.RHS.value
          }

          // Set RHS to same indicator as LHS, targeting the previous candle
          condition.condition.RHS = {
            indicator: _cloneDeep(condition.condition.LHS.indicator),
            field: condition.condition.LHS.field,
            candle: { offset: 1 },
          }
        }
      }
      if (group.conditionGroups?.length) {
        migrateGroups(group.conditionGroups)
      }
    }
  }

  migrateGroups(migrated.buyConditionGroups || [])
  migrateGroups(migrated.sellConditionGroups || [])
  return migrated
}
